import React from 'react';
import { createHashRouter, Navigate, RouterProvider } from 'react-router-dom';
import { MainLayout } from '../layouts';
import { Details, Documents, Failed, Home, Kyc, NotFound, Selection, ClaimReview } from '../../presentation';
import { DataProvider } from '../../adapter';

const router = createHashRouter([
    {
        index: true,
        element: <Navigate to="/claim-review" replace />
    },
    // {
    //     path: '/',
    //     element: <MainLayout />,
    //     children: [
    //         {
    //             index: true,
    //             element: <Navigate to="/home" replace />
    //         },
    //         {
    //             path: 'home',
    //             element: <Home />
    //         },
    //         {
    //             path: 'selection',
    //             element: <Selection />
    //         },
    //         {
    //             path: 'details',
    //             element: <Details />
    //         },
    //         {
    //             path: 'documents',
    //             element: <Documents />
    //         },
    //         {
    //             path: 'kyc',
    //             element: <Kyc />
    //         },
    //         {
    //             path: 'failed',
    //             element: <Failed />
    //         },
    //         {
    //             path: '*',
    //             element: <NotFound />
    //         }
    //     ]
    // },
    {
        path: 'claim-review',
        element: <ClaimReview />
    },
    {
        path: '*',
        element: <NotFound />
    }
]);

export default function MainRoutes() {
    return (
        <DataProvider>
            <RouterProvider router={router}>
                <Navigate to="/" replace />
            </RouterProvider>
        </DataProvider>
    );
}
